import { FC } from "react";
import { observer } from "mobx-react";
import { Dialog } from "@/components-v2/Dialog";
import { Box, Grid, GridItem, VBox } from "@/components-v2/Box";
import { MSelect } from "@/components-v2/Select";
import { MRadioButtonGroup } from "@/components-v2/RadioButton";
import { MDateInput } from "@/components-v2/DateInput";
import { useTranslation } from "@/stores/RootStoreContext";

import { InfoButton } from "@/components-v2/InfoButton";
import { ExportShareholderModel } from "./ExportShareholdersDomain";
import { PortfolioCompanySelector } from "./PortfolioCompanySelector";
import { Markdown } from "@/text/Markdown";
import { CompanySelectorContextType } from "./portfolioCompanySelectorDomain";

const ExportShareholders: FC<{ model: ExportShareholderModel }> = observer(({ model }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      title={t("shareholders.exportContent.title")}
      submitLabel={t("shareholders.export")}
      onSubmit={model.handleSubmitExport}
      onCancel={model.onClose}
      isSubmitting={model.isLoading}
      maxWidth={"md"}
      isSubmitDisabled={model.isSubmitDisabled}
    >
      <Grid gap={"xl"} justifyContent={"space-between"}>
        {model.isBatchExport && (
          <GridItem xs={6} marginRight={"lg"}>
            <VBox gap={"md"}>
              <PortfolioCompanySelector
                title={t("shareholders.exportCompanies.title")}
                companies={model.companies}
                companySelectorContext={model.companySelectorContext}
              />
              {model.companySelectorContext.value?.type === CompanySelectorContextType.COMPANY && (
                <Markdown value={t("shareholders.exportCompanies.tip")} enableLinks />
              )}
            </VBox>
          </GridItem>
        )}
        <GridItem xs={model.isBatchExport ? 6 : 12}>
          <VBox gap={"xl"}>
            <MSelect label={t("shareholders.exportContent.label")} model={model.content} />
            <VBox>
              <label htmlFor={"exportDate"}>
                <Box>
                  {t("shareholders.exportContent.per-date")}
                  <InfoButton infoText={t("shareholders.exportContent.info")} />
                </Box>
              </label>
              <MDateInput id={"exportDate"} model={model.exportDate} />
            </VBox>
            <VBox>
              <div>{t("shareholders.exportLanguage.select")}</div>
              <MRadioButtonGroup name={"exportLanguage"} model={model.language} horizontal />
            </VBox>
            <VBox>
              <div>{t("shareholders.exportContent.label")}</div>
              <MRadioButtonGroup name={"exportFormat"} model={model.exportFormat} horizontal />
            </VBox>
          </VBox>
        </GridItem>
      </Grid>
    </Dialog>
  );
});

export default ExportShareholders;
